import { render, staticRenderFns } from "./ScriptCard.vue?vue&type=template&id=3ec903c7"
import script from "./ScriptCard.vue?vue&type=script&lang=js"
export * from "./ScriptCard.vue?vue&type=script&lang=js"
import style0 from "./ScriptCard.vue?vue&type=style&index=0&id=3ec903c7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports